/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, group: NonNullable<unknown> }} Assistant_Activity_Read_EventsInputs */



/**
* | output |
* | --- |
* | "Read {count} events in {group}" |
*
* @param {Assistant_Activity_Read_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_read_events = /** @type {((inputs: Assistant_Activity_Read_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_Read_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Lire les événements ${i?.count} dans ${i?.group}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Lies die Ereignisse von ${i?.count} in ${i?.group}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Leggi gli eventi di ${i?.count} in ${i?.group}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Прочитайте события ${i?.count} в ${i?.group}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Lee los eventos ${i?.count} en ${i?.group}.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`读取 ${i?.group} 中的 ${i?.count} 事件`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.group} で ${i?.count} イベントを読み込む`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.group} में ${i?.count} इवेंट पढ़ें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Leia os eventos ${i?.count} em ${i?.group}`)
	return /** @type {LocalizedString} */ (`Read ${i?.count} events in ${i?.group}`)
});